import React, { useState } from "react";
import { Sparkles } from "lucide-react";
import { streamFetch } from "../lib/api";
import { readSse } from "../lib/sse";
import { logError } from "../lib/log";

export function MistakeExplain({ mistake }) {
  const [text, setText] = useState(mistake.ai_explanation || "");
  const [open, setOpen] = useState(!!mistake.ai_explanation);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const explain = async () => {
    setOpen(true);
    if (text) return;
    setBusy(true);
    setErr(null);
    try {
      const resp = await streamFetch(`/me/mistakes/${mistake.id}/explain`, { method: "POST" });
      if (!resp.ok || !resp.body) throw new Error(`Explain failed (${resp.status})`);
      let acc = "";
      await readSse(resp, (chunk) => { acc += chunk; setText(acc); });
    } catch (e) {
      logError("Mistake explain failed", e);
      setErr("ChemBuddy couldn't explain this right now. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3" data-testid={`mistake-explain-${mistake.id}`}>
      {!open ? (
        <button onClick={explain} data-testid={`mistake-explain-btn-${mistake.id}`} className="inline-flex items-center gap-1 rounded-md border border-fuchsia-400/40 bg-fuchsia-500/10 px-3 py-1 text-xs text-fuchsia-200 hover:bg-fuchsia-500/20">
          <Sparkles size={12} /> Explain my mistake
        </button>
      ) : (
        <div className="rounded-md border border-fuchsia-400/30 bg-fuchsia-500/5 p-3 text-sm leading-relaxed text-slate-200" data-testid={`mistake-explain-text-${mistake.id}`}>
          <div className="mb-1 flex items-center gap-1 text-[10px] uppercase tracking-widest text-fuchsia-300"><Sparkles size={10} /> ChemBuddy explains</div>
          {err ? (
            <span className="text-red-200">{err} <button onClick={() => { setOpen(false); }} className="underline">Retry</button></span>
          ) : (
            <span className="whitespace-pre-wrap">{text || (busy && <span className="font-mono-num text-slate-500">▍ thinking…</span>)}</span>
          )}
        </div>
      )}
    </div>
  );
}
